import smsHistoryReducer from "./smsHistoryReducer";

const smsReducers = {
    smsHistory: smsHistoryReducer
}

export default smsReducers;